import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

import { SearchTabs } from "~/components/search-results-page/types";
import { Params } from "~/constants/request";

import { pushHistoryState } from "./history";

export interface updatePageNumberOnSrpProps {
  pageNumber?: number;
  searchParams: URLSearchParams;
  pathname: string;
  router: AppRouterInstance;
}

export const updatePageNumberOnUrl = ({
  pageNumber,
  searchParams,
  pathname,
  router,
}: updatePageNumberOnSrpProps) => {
  const currentPage = pageNumber ? pageNumber : 1;
  const shouldHide = currentPage === 1;
  const hash = location.hash || "";

  const query = new URLSearchParams(searchParams);
  const prevPage = query.get(Params.PAGE);

  if (shouldHide) {
    query.delete(Params.PAGE);
  } else {
    query.set(Params.PAGE, JSON.stringify(currentPage));
  }

  const newParams = `?${query.toString()}${hash}`;
  const newUrl = `${pathname}${newParams}`;
  // For the first click on the 'load more' button we want to use
  // router.push because history.pushState cause 'glitching' of the scrolling
  if (!prevPage) {
    router.replace(newParams, { scroll: false });
  } else {
    // For other cases we must use history.pushState as it allowes to update page number in url before redirect
    // and we need to use router.push as well for updating page number in title
    pushHistoryState(newParams, { pathname });
    router.push(newParams, { scroll: false });
  }

  return newUrl;
};

export const updatePageNumberOnSrpArticles = ({
  pageNumber,
  searchParams,
  pathname,
  router,
}: updatePageNumberOnSrpProps): void => {
  const currentPage = pageNumber ? pageNumber : 1;
  const shouldHide = currentPage === 1;
  const hash = location.hash || "";

  const query = new URLSearchParams(searchParams);
  const prevPage = query.get(Params.PAGE);

  query.set(Params.TAB, SearchTabs.ARTICLES);
  if (shouldHide) {
    query.delete(Params.PAGE);
  } else {
    query.set(Params.PAGE, JSON.stringify(currentPage));
  }

  if (!prevPage) {
    const newUrl = `?${query.toString()}${hash}`;
    return router.push(newUrl, { scroll: false });
  }

  pushHistoryState(`${pathname}?${query.toString()}${hash}`, { pathname });
};
